import Logger from '@diziner/Logger';
export class Settings {
    /**
     * Setup the settings class, will use defaults if no parameter is passed.
     * @see getDefaultSettings
     * @param settings
     */
    constructor(settings) {
        if (typeof settings === 'undefined') {
            this._settings = Settings.getDefaultSettings();
            Logger.instance.debug('Constructed Settings with default settings');
        }
        else {
            this._settings = settings;
        }
    }
    static get instance() {
        if (typeof Settings._instance === 'undefined') {
            this._instance = new Settings();
        }
        return this._instance;
    }
    get transitions() {
        return this._settings.transitions;
    }
    get siteUrl() {
        return this._settings.siteUrl;
    }
    set siteUrl(value) {
        this._settings.siteUrl = value;
    }
    get searchUrl() {
        return this._settings.searchUrl;
    }
    set searchUrl(value) {
        this._settings.searchUrl = value;
    }
    get scriptDebug() {
        return this._settings.scriptDebug;
    }
    set scriptDebug(value) {
        this._settings.scriptDebug = value;
    }
    get adminAjaxUrl() {
        return this._settings.adminAjaxUrl;
    }
    set adminAjaxUrl(value) {
        this._settings.adminAjaxUrl = value;
    }
    get ajaxUrl() {
        return this._settings.ajaxUrl;
    }
    set ajaxUrl(value) {
        this._settings.ajaxUrl = value;
    }
    get issueName() {
        return this._settings.issueName;
    }
    get googleAnalyticsCode() {
        return this._settings.googleAnalyticsCode;
    }
    static getDefaultSettings() {
        const origin = window.location.origin;
        return {
            issueId: 0,
            issueName: '',
            issueTitle: '',
            adminAjaxUrl: origin + '/wp-admin/admin-ajax.php',
            ajaxUrl: origin + '/wp-content/plugins/diziner-core/ajax.php',
            searchUrl: origin + '/wp-content/plugins/diziner-core/ajax.php',
            siteUrl: origin,
            scriptDebug: false,
            isUserLoggedIn: false,
            googleAnalyticsCode: '',
            loginRequired: false,
            transitions: {
                entry: 3,
                back: 6,
                forward: 5,
            },
        };
    }
    async updateSettingsFromGlobal() {
        return new Promise((resolve, reject) => {
            if (Object.prototype.hasOwnProperty.call(window, 'browser_options')) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                const browser_options = window.browser_options;
                this._settings.issueId = browser_options.issueId;
                this._settings.issueName = browser_options.issueName;
                this._settings.issueTitle = browser_options.the_title;
                this._settings.ajaxUrl = browser_options.ajaxurl;
                this._settings.siteUrl = browser_options.site_url;
                this._settings.isUserLoggedIn = browser_options.is_user_logged_in;
                this._settings.googleAnalyticsCode = browser_options.google_analytics_tid;
                this._settings.scriptDebug = browser_options.script_debug;
                this._settings.loginRequired = browser_options.login_required;
                this._settings.transitions = {
                    entry: parseInt(browser_options.transitions.entry),
                    back: parseInt(browser_options.transitions.back),
                    forward: parseInt(browser_options.transitions.forward),
                };
                resolve(true);
            }
            reject(false);
        });
    }
}
